import React, { useEffect, useState } from "react";
import { AutoComplete, Button, DatePicker, Form, Select, Spin } from "antd";
import dayjs from "dayjs";

import Devices from "services/devices";
import { Device } from "types";
import { DEFAULT_DATETIME_FORMAT } from "utils/datetime";
import { SCMaxULogsFilter } from "../../types";

const { Option } = Select
const { RangePicker } = DatePicker

interface SCMaxULogsFiltersProps {
	onSubmit: (values: any) => void;
	loading: boolean
	filters?: SCMaxULogsFilter
}

const SCMaxULogsFilters: React.FC<SCMaxULogsFiltersProps> = ({ onSubmit, filters, loading }) => {
	// ----- Data -----
	const [device, setDevices] = useState<Device[]>([]);
	const [loadingDevices, setLoadingDevices] = useState(false);
	// ----- Form -----
	const [form] = Form.useForm();

	useEffect(() => {
		if (!filters) return
		const rids = Array.isArray(filters?.rids) ? filters?.rids : (filters?.rids ? [filters?.rids] : [])
		form.setFieldsValue({
			rids: rids,
			dateRange: filters?.startDate && filters?.endDate && [dayjs(filters?.startDate), dayjs(filters?.endDate)],
			macAddress: filters?.macAddress
		})
	}, [filters])

	const fetchMacAddresses = async (value: any) => {
		if (!value || value.length < 3) {
			setDevices([]);
			return
		}
		setLoadingDevices(true);
		try {
			const params = {
				filters: {
					mac_address: value
				},
			}
			const response = await Devices.getAllUsersDevices(params);
			// console.log("response", response)
			const responseData = response.data.items || [];
			setDevices(responseData);
		} catch (err) {
			// console.error('Error fetching')
		}
		setLoadingDevices(false);
	};

	const handleFinish = (values: any) => {
		const startDate = values?.dateRange && values?.dateRange[0] || null
		const endDate = values?.dateRange && values?.dateRange[1] || null
		const filters: SCMaxULogsFilter = {
			rids: values?.rids || null,
			startDate: startDate && dayjs(startDate).format(DEFAULT_DATETIME_FORMAT) || null,
			endDate: endDate && dayjs(endDate).format(DEFAULT_DATETIME_FORMAT) || null,
			macAddress: values?.macAddress || null
		}
		onSubmit(filters);
	}

	return (
		<>
			<Form layout="vertical" form={form} onFinish={handleFinish}
				initialValues={{ macAddress: '' }}
			>
				<Form.Item
					name="macAddress"
					label="MAC Address"
					rules={[{ required: true, message: "Please input a valid mac address" }]}
				>
					<AutoComplete
						options={device.map(item => ({ value: item.macAddress, key: item.macAddress }))}
						onSearch={fetchMacAddresses}
					/>
				</Form.Item>
				<Spin size="small" spinning={loadingDevices} />
				<Form.Item name="rids" label="Types">
					<Select allowClear mode="multiple" optionFilterProp="key">
						<Option key="SelectFilterTimestamp" value="1">Timestamp</Option>
						<Option key="SelectFilterRebootShutdown" value="2">RebootShutdown</Option>
						<Option key="SelectFilterTimeDelta" value="3">TimeDelta</Option>
						<Option key="SelectFilterTimer" value="6">Timer</Option>
						<Option key="SelectFilterFinding" value="7">Finding</Option>
						<Option key="SelectFilterZap" value="17">Zap</Option>
						<Option key="SelectFilterHandDetect" value="21">HandDetect</Option>
						<Option key="SelectFilterEnergy" value="32">Energy</Option>
						<Option key="SelectFilterSleep" value="33">SleepSession</Option>
						<Option key="SelectFilterSteps" value="34">Steps</Option>
						<Option key="SelectFilterMark" value="35">Mark</Option>
						<Option key="SelectFilterRestingHeartRate" value="37">RestingHeartRate</Option>
						<Option key="SelectFilterHeartRate" value="38">HeartRate</Option>
					</Select>
				</Form.Item>
				<Form.Item name="dateRange" label="Date Range">
					<RangePicker showTime />
				</Form.Item>
				<Form.Item>
					<Button type="primary" htmlType="submit" loading={loading}>Filter</Button>
				</Form.Item>
			</Form>
		</>
	)
}

export default SCMaxULogsFilters
